import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
export class SpecificationsFormulaValidator {

    type_field = [
        Validators.required
    ];
    value_type = [
        Validators.required
    ];
    lang_code = [
        Validators.required
    ]

    // Error messages
    errorMessages = {

        type_field: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        value_type: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        lang_code: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}